// extracted by mini-css-extract-plugin
module.exports = {"blockCommon":"back-button__blockCommon___qIxds","backButton":"back-button__backButton___3l4CP"};